import { render, staticRenderFns } from "./ProcessExcellenceColumn.vue?vue&type=template&id=515be4ac&scoped=true&"
import script from "./ProcessExcellenceColumn.vue?vue&type=script&lang=js&"
export * from "./ProcessExcellenceColumn.vue?vue&type=script&lang=js&"
import style0 from "./ProcessExcellenceColumn.vue?vue&type=style&index=0&id=515be4ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515be4ac",
  null
  
)

export default component.exports